import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DistributorsService } from '../services/distributors.service';
import { DistributorContractsService } from '../services/distributor-contracts.service';
import { DistributorProductsService } from '../services/distributor-products.service';
import { ConfirmationService } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';
import { Distributor } from '../../models/distributor';
import { Response } from '@angular/http';
import { environment } from '../../../environments/environment';
import { DistributorContract } from '../../models/distributor-contract';
import { DistributorProduct } from '../../models/distributor-product';
import { BreadcrumbService } from '../../breadcrumb/breadcrumb.service';
import {GroupRight} from '../../models/group-right';
import {GroupRightService} from '../../services/group-right.service';

@Component({
	selector: 'app-distributor-detail',
	templateUrl: './distributor-detail.component.html'
})
export class DistributorDetailComponent implements OnInit
{
	public distributor: Distributor;
	public isNew: boolean;
	public activeContract : DistributorContract;
	public groupRight: GroupRight = null;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private distributorsService: DistributorsService,
		private distributorContractsService: DistributorContractsService,
		private distributorProductsService: DistributorProductsService,
		private breadcrumbService: BreadcrumbService,
		private confirmationService: ConfirmationService,
		private messageService: MessageService,
		private	groupRightService: GroupRightService
	)
	{
	}

	ngOnInit()
	{
		if (this.route.snapshot.data['groupRights'] instanceof Array) {
			this.groupRight = this.groupRightService.getGroupRightForModule('distributor', this.route.snapshot.data['groupRights'])
		}

		if (this.route.snapshot.data['distributor'] instanceof Object && !(this.route.snapshot.data['distributor'] instanceof Response))
		{
			// Distributor was received.
			this.distributor = this.route.snapshot.data['distributor'];
			this.breadcrumbService.addBreadcrumbTranslation(this.route.snapshot.data['breadcrumb'], this.distributor.name);
			this.isNew = false;
		}
		else
		{
			// We are creating a new Distributor, or something went wrong.
			this.distributor = new Distributor();
			this.isNew = true;

			if (this.route.snapshot.data['distributor'] instanceof Response)
			{
				let errorMessage = 'Er is een fout opgetreden tijdens het ophalen van de verspreider.';

				if (this.route.snapshot.data['distributor'].status == 403) {
					errorMessage = 'Je hebt niet genoeg rechten voor deze actie.';
				}
				// We got an unhandled exception, let's show a message.
				this.messageService.add({
					severity: 'error',
					summary: 'Fout',
					detail: errorMessage
				});

				if (this.route.snapshot.data['distributor'].status == 403) {
					this.goBack();
				}
			}
		}

		let activeFrom = null;
		let activeContract = null;

		this.distributor.distributorContracts.forEach( (distributorContract) => {
			if(activeFrom == null && !distributorContract.inactive  ) {
				activeFrom = new Date(distributorContract.active_from);
				activeContract = distributorContract;
			} else if( new Date(distributorContract.active_from) > activeFrom && !distributorContract.inactive ) {
				activeFrom = new Date(distributorContract.active_from);
				activeContract = distributorContract;
			}
		});

		this.activeContract = activeContract;
	}

	public getDisabled( distributorContract )
	{
    if (!distributorContract.inactive) {
      return "";
    }

		return "disabled";
	}

	public goBack()
	{
		this.router.navigate(['/verspreiders']);
	}

	public saveDistributor()
	{
		let promise: Promise<Distributor>;
		if (this.isNew)
		{
			promise = this.distributorsService.storeDistributor(this.distributor);
		}
		else
		{
			promise = this.distributorsService.updateDistributor(this.distributor);
		}

		promise.then((data) =>
		{
			if (data instanceof Response)
			{
				if (data.status === 422)
				{
					const shownMessages: Array<string> = [];
					const message: Object = data.json().message;

					Object.keys(message).forEach((fieldName) =>
					{
						message[fieldName].forEach((message) =>
						{
							if (shownMessages.indexOf(message) === -1)
							{
								shownMessages.push(message);

								this.messageService.add({
									severity: 'warning',
									summary: 'Validatiefout',
									detail: environment.validation.distributor[message]
								});
							}
						});
					});
				} else if (data.status == 403) {
					this.messageService.add({
						severity: 'error',
						summary: 'Verspreider niet opgeslagen',
						detail: 'Je hebt te weinig rechten voor deze actie.'
					});
				}
				else
				{
					this.messageService.add({
						severity: 'error',
						summary: 'Verspreider niet opgeslagen',
						detail: 'Er is een fout opgetreden tijdens het opslaan van de verspreider.'
					});
				}
			}
			else
			{
				this.messageService.add({
					severity: 'success',
					summary: 'Verspreider opgeslagen',
					detail: 'De verspreider is opgeslagen.'
				});

				this.router.navigate(['/verspreiders/' + data.id]);
			}
		});
	}

	public removeDistributor()
	{

		this.confirmationService.confirm({
			message: 'Weet u zeker dat u deze verspreider wilt verwijderen?',
			header: 'Verspreider verwijderen?',
			icon: 'fa fa-trash',
			accept: () =>
			{
				this.distributorsService.removeDistributor(this.distributor.id)
					.then((response) =>
					{
						if (response.status != 403) {
							this.messageService.add({
								severity: 'success',
								summary: 'Verspreider verwijderd',
								detail: 'De verspreider is verwijderd.'
							});

							this.router.navigate(['/verspreiders']);
						} else {
							this.messageService.add({
								severity: 'error',
								summary: 'Verspreider niet verwijderd',
								detail: 'Je hebt niet genoeg rechten voor deze actie.'
							});
						}
					})
					.catch((data) =>
					{
						this.messageService.add({
							severity: 'error',
							summary: 'Verspreider niet verwijderd',
							detail: 'De verspreider kon niet worden verwijderd.'
						});
					});
			}
		});
	}

	public createProduct(product)
	{
		this.router.navigate(['/verspreiders/' + this.distributor.id + '/product/']);
	}

	public editProduct(product)
	{
		this.router.navigate(['/verspreiders/' + this.distributor.id + '/product/' + product.id]);
	}

	public createContract()
	{
		this.router.navigate(['/verspreiders/' + this.distributor.id + '/contracten/aanmaken']);
	}

	public openContract(contract: DistributorContract)
	{
		this.router.navigate(['/verspreiders/' + this.distributor.id + '/contracten/' + contract.id]);
	}

	public hasUserAccess(action: string)
	{
		return this.groupRight && this.groupRight[action];
	}

	public duplicateContract(contract: DistributorContract)
	{
		this.confirmationService.confirm({
			message: 'Weet u zeker dat u contract wil dupliceren?',
			header: 'Contract Dupliceren?',
			icon: 'fa fa-save',
			accept: () =>
			{
				let promise: Promise<DistributorContract>;
				promise = this.distributorContractsService.duplicateDistributorContract(contract);

				promise.then((data) =>
				{
					if (data instanceof Response)
					{
						if (data.status === 422)
						{
							const shownMessages: Array<string> = [];
							const message: Object = data.json().message;

							Object.keys(message).forEach((fieldName) =>
							{
								message[fieldName].forEach((message) =>
								{
									if (shownMessages.indexOf(message) === -1)
									{
										shownMessages.push(message);

										this.messageService.add({
											severity: 'warning',
											summary: 'Validatiefout',
											detail: environment.validation.distributor_contract[message]
										});
									}
								});
							});
						}
						else
						{
							this.messageService.add({
								severity: 'error',
								summary: 'Contract niet opgeslagen',
								detail: 'Er is een fout opgetreden tijdens het opslaan van het contract.'
							});
						}
					}
					else
					{
						this.messageService.add({
							severity: 'success',
							summary: 'Contract opgeslagen',
							detail: 'Het contract is opgeslagen.'
						});

						this.router.navigate(['/verspreiders/' + data.distributor.id + '/contracten/' + data.id]);
					}
				});
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/distributors/distributor-detail/distributor-detail.component.ts